import {clone} from 'lodash';
import number from './number';

const percentage = clone(number);

percentage.format = function formatPercent(v) {
  return `${parseFloat(v * 100).toFixed(2)}%`;
};

export default percentage;



// WEBPACK FOOTER //
// ./src/components/vue-good-table/components/types/percentage.js